export const editableRowTableStyles = {
  listContainer: {
    overflow: 'auto',
    '& th': {
      p: 2,
    },
  },
  tableFooter: {
    position: 'sticky',
    bottom: 0,
    // backgroundColor: 'white',
    p: 0.5,
    textAlign: 'center',
    borderTop: '1px rgb(128, 128, 128)',
  },
};
